// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoPanel_container__2fzw7","text":"InfoPanel_text__22Z-B","description":"InfoPanel_description__2XHRl"};